export default __webpack_public_path__ + "static/akai-professional-502f361bce46b4594711daeb8be6971c.svg";